interface LogoProps {
  size?: number;
  showText?: boolean;
  color?: string;
  textColor?: string;
}

// Dubs mark — stylized "D" monogram.
// Placeholder mark; replace with your brand's logo when rebranding.
export function Logo({
  size = 40,
  showText = false,
  color = 'var(--color-primary)',
  textColor = 'var(--color-on-surface)',
}: LogoProps) {
  return (
    <span
      className="inline-flex items-center"
      style={{ gap: size * 0.28 }}
    >
      <span
        aria-hidden
        style={{
          fontFamily: '"High Speed"',
          fontSize: size,
          lineHeight: 1,
          color,
          display: 'inline-block',
        }}
      >
        D
      </span>
      {showText && (
        <span
          className="font-display font-semibold"
          style={{
            fontSize: size * 0.55,
            color: textColor,
            letterSpacing: '-0.02em',
          }}
        >
          Dubs
        </span>
      )}
    </span>
  );
}
